import { createReducer } from 'reduxsauce'
import {
  UPDATE_RESIZE_VALUES,
  TOGGLE_RESIZE_RATIO_LOCK,
  SET_RESIZE_CHANGED_STATUS,
  SET_RESIZE_MODAL,
  SET_RESIZE_REDIRECT,
} from '../types/resize.types'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  resize: {
    width: 0,
    height: 0,
    isPercentage: false,
    locked: true,
    changed: false,
    id: 0,
  },
  resizeTo: '',
  showResizeModal: false,
})

export const updateResizeValues = (state, { payload: values }) => state.merge({ resize: { ...values } }, { deep: true })
export const toggleResizeRatioLock = (state, { payload: locked }) =>
  state.merge({ resize: { ...state.resize, locked } }, { deep: true })
export const setResizeChangedStatus = (state, { payload: status }) =>
  state.merge({ resize: { ...state.resize, changed: status } }, { deep: true })
export const setResizeModal = (state, { payload: status }) => state.merge({ showResizeModal: status }, { deep: true })
export const setResizeRedirect = (state, { payload: resizeTo }) => state.merge({ resizeTo }, { deep: true })

export const HANDLES = {
  [UPDATE_RESIZE_VALUES]: updateResizeValues,
  [TOGGLE_RESIZE_RATIO_LOCK]: toggleResizeRatioLock,
  [SET_RESIZE_CHANGED_STATUS]: setResizeChangedStatus,
  [SET_RESIZE_MODAL]: setResizeModal,
  [SET_RESIZE_REDIRECT]: setResizeRedirect,
}

export default createReducer(INITIAL_STATE, HANDLES)
